import { CButton, CFormInput, CFormLabel, CFormTextarea } from "@coreui/react";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import AxiosInstance from "src/components/Axios";
import { toast, ToastContainer } from 'react-toastify'




export default function PlanSafetyMeasures() {
   // хто увійшов
   const role = localStorage.getItem('user_role')
   // console.log(role)


   //для селекта
   const [safetyMeasuresTitle, setSafetyMeasuresTitle] = useState('')

   //для нового етапу в інпуті

   const [safetyMeasuresInputText, setSafetyMeasuresInputText] = useState('')

   //для нового етапу в інпуті
   const [safetyMeasuresDescriptionText, setSafetyMeasuresDescriptionText] = useState('')
   //для оновлення селекта
   const [reloadKey, setReloadKey] = useState(0)


   //стилі для селекту
   const customStyles = {
      menuList: (provided) => ({
         ...provided,
         maxHeight: '200px',
         overflowY: 'auto',
      }),
   };




   const loadOptions = async (inputValue = '') => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/safety_measures_lists?name=${inputValue}`
            // , header
         ).then((response) => {
            console.log('response.data', response.data)
            return response.data['hydra:member']?.map((result) => ({
               label: result.name,
               value: result.id,
            }));
         });
      } else {
         // if (userData.id) {
         //    return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
         //       return response.data.map((result) => ({
         //          label: result.name,
         //          value: result.id,
         //       }));
         //    });
         // }
         return []
      }
   }

   // функція для додавання типу
   function addItem() {
      if (safetyMeasuresInputText === '' || safetyMeasuresDescriptionText === '') return

      const send_data = {
         name: safetyMeasuresInputText,
         description: safetyMeasuresDescriptionText
      }

      AxiosInstance.post(`/safety_measures_lists`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         // return response.data.map((result) => ({
         //    label: result.name,
         //    value: result.id,
         // }));
         toast.success('Новий захід з ОП додано')
         setSafetyMeasuresInputText('')
         setSafetyMeasuresDescriptionText('')
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Новий захід з ОП не додано'));

   }




   if (role !== 'ROLE_ADMIN') { return }

   return (
      <>
         {/* Частина з реакт селектом Заходів з ОП */}
         <div>
            <h2>Список заходів з ОП</h2>
            <AsyncSelect
               key={reloadKey}
               cacheOptions
               loadOptions={loadOptions}
               defaultOptions
               // value={partnerFilterSearch}
               // onChange={handleChangePartner}
               className="flex-grow-1"
               placeholder="Заходи з ОП"
               styles={customStyles}
            />
         </div>
         {/* Частина для додавання нового заходу з ОП до довідника з інпутом для назви */}
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput1">Введіть назву заходу з ОП</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput1"
               defaultValue="Введіть назву нового заходу з ОП"
               value={safetyMeasuresInputText}
               onChange={(e) => setSafetyMeasuresInputText(e.target.value)}
               placeholder="Введіть назву заходу з ОП"
               autoComplete="off"
            />

         </div>


         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Введіть опис заходу з ОП</CFormLabel>
            <CFormTextarea
               type="text"
               id="exampleFormControlInput2"
               // defaultValue="Введіть опис нового етапу"
               value={safetyMeasuresDescriptionText}
               onChange={(e) => setSafetyMeasuresDescriptionText(e.target.value)}
               placeholder="Введіть опис заходу з ОП"
               autoComplete="off"
            />

         </div>
         <CButton className="mt-3" onClick={addItem} >Додати</CButton>
      </>
   )
}